import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeNotification } from '../../redux/notifications/actions';
import { NotificationMessage } from '../../redux/notifications/types';
import StateInterface from '../../redux/types';
import useShowPromoBarBanner from '../../hooks/flags/useShowPromoBarBanner';
import Notifications from './Notifications';
import { HeaderModeType, useLayoutByPage } from 'Client/hooks/useLayoutByPage';

const ConnectedNotifications: React.SFC = () => {
    const dispatch = useDispatch();
    const messages = useSelector<StateInterface, NotificationMessage[]>(state => state.notifications.messages);
    const isBannerShown = useShowPromoBarBanner();

    const removeMessage = useCallback(
        (messageId: string) => {
            dispatch(removeNotification(messageId));
        },
        [dispatch]
    );

    const { headerMode } = useLayoutByPage();
    if (headerMode === HeaderModeType.NONE) {
        return <></>;
    }

    return <Notifications messages={messages} dismissMessage={removeMessage} isBannerShown={isBannerShown} />;
};

export default ConnectedNotifications;
